module.exports = __webpack_public_path__ + "img/map-press-party.f9fcc3d9.png";